import { kuferClient } from '@xver/libs/axios';

import {
    BuildLogTicketResponse,
    CancelBuildResponse,
    GetBuildLogsQueryModel,
    GetBuildLogsResponse,
    GetBuildResponse,
    ListBuildsQueryModel,
    ListBuildsResponse,
    RebuildRequest,
    RebuildResponse,
} from './model';

const ENDPOINTS = {
    LIST: (containerId: string) => `/v1/containers/${containerId}/builds`,
    LATEST_LOGS: (containerId: string) => `/v1/containers/${containerId}/builds/logs`,
    GET: (containerId: string, buildId: string) =>
        `/v1/containers/${containerId}/builds/${buildId}`,
    GET_LOGS: (containerId: string, buildId: string) =>
        `/v1/containers/${containerId}/builds/${buildId}/logs`,
    LOG_TICKET: (containerId: string) => `/v1/containers/${containerId}/builds/logs/ticket`,
    CANCEL: (containerId: string, buildId: string) =>
        `/v1/containers/${containerId}/builds/${buildId}`,
    REBUILD: (containerId: string) => `/v1/containers/${containerId}/rebuild`,
};

export function listBuilds(
    containerId: string,
    params?: ListBuildsQueryModel
): Promise<ListBuildsResponse> {
    return kuferClient.get(ENDPOINTS.LIST(containerId), { params });
}

export function getBuild(containerId: string, buildId: string): Promise<GetBuildResponse> {
    return kuferClient.get(ENDPOINTS.GET(containerId, buildId));
}

export function getBuildLogs(
    containerId: string,
    buildId: string,
    params?: GetBuildLogsQueryModel
): Promise<GetBuildLogsResponse> {
    return kuferClient.get(ENDPOINTS.GET_LOGS(containerId, buildId), { params });
}

export function getLatestBuildLogs(
    containerId: string,
    params?: GetBuildLogsQueryModel
): Promise<GetBuildLogsResponse> {
    return kuferClient.get(ENDPOINTS.LATEST_LOGS(containerId), { params });
}

export function requestBuildLogTicket(containerId: string): Promise<BuildLogTicketResponse> {
    return kuferClient.post(ENDPOINTS.LOG_TICKET(containerId));
}

export function cancelBuild(containerId: string, buildId: string): Promise<CancelBuildResponse> {
    return kuferClient.delete(ENDPOINTS.CANCEL(containerId, buildId));
}

export function rebuildContainer(
    containerId: string,
    data?: RebuildRequest
): Promise<RebuildResponse> {
    return kuferClient.post(ENDPOINTS.REBUILD(containerId), data ?? {});
}
